import { Component, OnInit, forwardRef, Input, Output, EventEmitter, Optional } from '@angular/core';
import { Account } from 'src/app/models/account.model';
import { CommonService } from 'src/app/services/common.service';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Subscription } from 'rxjs';
import { NavigationStart, Router } from '@angular/router';

@Component({
  selector: 'app-account-list',
  templateUrl: './account-list.component.html',
  styleUrls: ['./account-list.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => AccountListComponent),
      multi: true
    }
  ]
})
export class AccountListComponent implements OnInit, ControlValueAccessor {
  onChange = (_: any) => { }
  onTouched: () => {};
  selectedClientCode: string = '';
  writeValue(clientCode: string): void {
    this.onChange(clientCode);
  }
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
  @Output() sendList = new EventEmitter<Account[]>();
  @Input() includeAllOption: boolean = false;
  @Input() isExternal: boolean = false;
  
  /**Subscripción a observable de cuentas cargadas */
  accountListLoadedSubscription: Subscription;
  accountList: Account[];
  pathActiveStyleComboBlue:any[] = ['/ofivirtual', '/ofivirtual/tienda', '/ofivirtual/tienda/carrito', '/ofivirtual/tienda/mis-pedidos', '/ofivirtual/tienda/producto']
  isComboBlue:boolean = false;
  constructor(
    private commonService: CommonService, private router: Router) {
    this.accountListLoadedSubscription = this.commonService.accountListLoadedAnnounced.subscribe(accountList => {
      this.accountList = accountList;
      this.sendList.emit(this.accountList);
      // if (this.includeAllOption) this.accountSelected('');
      // else if (accountList.length > 0) this.accountSelected(this.accountList[0].clientCode);
      setTimeout(() => {  //[pending]
        if (this.includeAllOption) this.accountSelected('');
        else if (accountList.length > 0) this.accountSelected(this.accountList[0].clientCode);
      }, 100);
    })
    
    if (this.pathActiveStyleComboBlue.includes(this.router.url)) {
      this.isComboBlue = true;
    }else{
      this.isComboBlue = false;
    }
  }

  async ngOnInit() {
    this.sendList.emit(this.accountList);

    this.router.events.subscribe((event) => {
      if ( event instanceof NavigationStart) {
         if (this.pathActiveStyleComboBlue.includes(this.router.url)) {
           this.isComboBlue = true;
         }
         else{
           this.isComboBlue = false;
         }
      }
    });
  }
  accountSelected(clientCode: string) {
    const accountSelected = this.accountList.find(x => x.clientCode === clientCode);
    this.commonService.announceAccountSelected(accountSelected);
    this.selectedClientCode = clientCode;
    this.onChange(clientCode);
  }
  ngOnDestroy() {
    this.accountListLoadedSubscription.unsubscribe();
    this.commonService.clearAccountSelectedAnnouncedSource();
  }
}
